import React from "react";
import { Spinner } from "@abb/abb-common-ux-react";

export const GridLoadingOverlay = () => {
  return <Spinner sizeClass="large" color="red" />;
};
